import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { Poppins, Spacer, TextOverflowTooltip } from 'src/common';
import { Tile, TileDescription, TileDescriptionContainer, TileTitle } from 'src/components/Tile';
import { ScenarioSvg } from 'src/assets/dynamicSvg';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { ScenarioGroupSummary } from 'src/graphql';
import CommonMenu from 'src/components/CommonMenu';
import { ThreeDots } from 'src/components/CommonMenu/comps';

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface ScenarioGroupCardProps {
  group: ScenarioGroupSummary;
}

export const ScenarioGroupCard: React.FC<ScenarioGroupCardProps> = ({ group }) => {
  const navigate = useNavigate();
  const scenarioCount = group.scenarios?.length ?? 0;
  const [anchorEl, setAnchorEl] = React.useState<React.MouseEvent['currentTarget'] | null>(null);

  const goToGroup = () => {
    navigate(`/scenario-library/groups/${group.id}`);
    mpEvent(MPEvents.Link, {
      source: { value: ['Scenario Library'] },
      destination: { value: ['Scenario Library'], params: { id: group.id } },
      tags: ['SCENARIO'],
    });
  };

  return (
    <>
      <CommonMenu
        onViewClick={(e) => {
          e.stopPropagation();
          setAnchorEl(null);
          goToGroup();
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      />
      <Tile
        className="hover-shadow"
        onClick={() => {
          if (!anchorEl) goToGroup();
        }}
        data-cy="scenario-group-card"
      >
        <div css="display: flex;justify-content: space-between;align-items: center;">
          <TextOverflowTooltip tooltipText={group.name || ''}>
            <Link
              to={`/scenario-library/groups/${group.id}`}
              onClick={(e) => {
                e.stopPropagation();
              goToGroup();
            }}
          >
            <TileTitle>{group.name}</TileTitle>
          </Link>
        </TextOverflowTooltip>
          <ThreeDots
            onClick={(e) => {
              e.stopPropagation();
              setAnchorEl(e.currentTarget);
            }}
          />
        </div>
        <Spacer $px={10} />
        <TileDescriptionContainer>
          <TileDescription>
            {group.author && (
              <Poppins px={14} color="cflowerBlue">
                {group.author}
              </Poppins>
            )}
            {group.description && (
              <Poppins px={14} css="display: block;">
                {group.description}
              </Poppins>
            )}
          </TileDescription>
        </TileDescriptionContainer>
        <Footer>
          <div css="display: flex;align-items: center;flex: 1;">
            <ScenarioSvg />
            <div>
              <Poppins css="margin-left: 6px;" px={14}>
                {group.category ? `${group.category} • ` : ''}
              </Poppins>
              <Poppins px={14} weight={600}>
                {scenarioCount}{' '}
              </Poppins>
              <Poppins px={14}>{scenarioCount === 1 ? 'scenario' : 'scenarios'}</Poppins>
            </div>
          </div>
        </Footer>
      </Tile>
    </>
  );
};
